export default "__VITE_ASSET__6sChGaxO__"